'use client';
import Button from '@/components/Button';
import TirageTable from '@/components/homePage/TirageTable';
import { formatDate } from '@/helpers/stringFormatHelper';
import { fetchReceiptModel } from '@/services/achats';
import Errors from '@/services/errors';
import { useSearchParams } from 'next/navigation';
import { useContext, useEffect, useState } from 'react';
import { ConnectedStateContext, ToastContext } from './Layout';

const Receipts = () => {
  const updateToast = useContext(ToastContext);
  const searchParams = useSearchParams();
  const tirageId = searchParams.get('tirageId');
  const refresh = searchParams.get('refresh');

  const [isConnected] = useContext(ConnectedStateContext);
  const [model, setModel] = useState({
    achats: [],
    tirage: {
      dateOuvertureString: '',
    },
  });

  if (refresh) {
    window.location.href = '/receipts?tirageId=' + tirageId;
  }

  const fetchReceipts = async (tirageId) => {
    try {
      const result = await fetchReceiptModel(tirageId);
      if (result instanceof Error) {
        throw result;
      }
      setModel(result);
    } catch (e) {
      console.error(e);
      Errors.handleError(e, updateToast);
    }
  };

  useEffect(() => {
    fetchReceipts(tirageId);
  }, []);

  return (
    <>
      <div className="hero card sales-card my-3 py-3">
        <div className="card-title">
          <h2 className="text-center">Achat de cartes de BINGO</h2>
        </div>
        <div className="card-body">
          <h3 className="text-center fw-bold mb-3">Informations du tirage</h3>
          <div className="row">
            <div
              className="col-12 col-md-3 col-lg-2 text-center text-decoration-underline fw-bold fs-4 d-flex align-items-center ps-3 mb-3">
              <span>{model?.tirage?.dateOuvertureString}</span>
            </div>
            <div className="col-12 col-md-9 col-lg-10">
              <TirageTable tirage={model?.tirage} model={model} lines={1}/>
            </div>
          </div>
        </div>
      </div>
      <div className="alert alert-warning fw-bold">
        ATTENTION - Les cartes peuvent prendre plusieurs minutes avant d&apos;être générées
      </div>
      {isConnected && (
        <>
          <div className="card card-3-light mb-3 py-3">
            <div className="card-tiltle">
              <h2 className={'text-center fw-bold'}>Tirages</h2>
            </div>
            <div className="card-body">
              <div className="row justify-content-center">
                {model?.achats?.map((receipt, index) => (
                  <ReciptCard receipt={receipt} key={index}/>
                ))}
              </div>
            </div>
          </div>
        </>
      )}
      <iframe id={'pdfFrame'} className={'w-100'} scrolling={'auto'}></iframe>
    </>
  );
};

export default Receipts;
const ReciptCard = ({ receipt }) => {
  const [disableButton, setDisableButton] = useState(false);
  const updateToast = useContext(ToastContext);
  const handlePrintCards = (receipt) => async () => {
    try {
      const url = '/api/receipts/' + `${receipt.id}.pdf`;
      window.open(url, '_blank');

      setDisableButton(false);
    } catch (e) {
      Errors.handleError(e, updateToast);
    }
  };

  return (
    <div className=" col-12 col-md-6 col-lg-6 col-xl-4 px-md-3 mb-3">
      <div className="bg-body-tertiary rounded-4 p-4">
        <h3 className={'text-center'}> Votre Reçu</h3>
        <div className="row mb-2">
          <div className="col-6">Date D&apos;achat&nbsp;:</div>
          <div className="col-6">{formatDate(receipt.dateAchat)}</div>
        </div>
        <div className="row mb-2">
          <div className="col-6">Montant d&apos;achat&nbsp;:</div>
          <div className="col-6">{receipt.montant}$</div>
        </div>
        <div className="row mb-2">
          <div className="col-6">No de commande&nbsp;:</div>
          <div className="col-6 ">
            <small>{receipt.orderId}</small>
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-6">No de carte&nbsp;:</div>
          <div className="col-6">{receipt.maskedCardNo}</div>
        </div>
        <div className="row mb-2">
          <div className="col-6">No d&apos;autorisation&nbsp;:</div>
          <div className="col-6">{receipt.authorizationCode}</div>
        </div>
        <div className="row mb-2">
          <div className="col-6">No de référence&nbsp;:</div>
          <div className="col-6">{receipt.referenceNo}</div>
        </div>
        <div className="row mb-2">
          <div className="col-6">Code de réponse&nbsp;:</div>
          <div className="col-6">{receipt.responseCode}</div>
        </div>

        <div className="row justify-content-center">
          <div className="col-auto">
            {receipt.achatCartes.length > 0 && !disableButton && (
              <Button
                className="btn btn-primary mt-3"
                onClick={handlePrintCards(receipt)}
                disabled={disableButton}
              >
                Voir les cartes
              </Button>
            )}
            {(disableButton || receipt.achatCartes.length === 0) && (
              <Button
                className="btn btn-secondary"
                onClick={() => {
                  window.location.reload();
                }}
              >
                Vos cartes sont en cours de génération... rafraichir la page.
              </Button>
            )}
          </div>
          {disableButton && (
            <small className={'text-info'}>
              une fois les cartes obtenues, elles seront affichées dans un nouvel onglet, ou téléchargées.
            </small>
          )}
        </div>
      </div>
    </div>
  );
};
